export default "__VITE_ASSET__DYTVGvgf__"